import { Loader } from '@acast/decibel';
import { resolve } from 'acast-www-utils';
import T from 'prop-types';
import React from 'react';
import { getImage } from 'services/image-api';
import limitWithEllipsis from 'shared/helpers/limit-with-ellipsis';
import { showPropType } from '../../../../customPropTypes';

const DEFAULT_CHANNEL_IMAGE = '/assets/images/default-show.png';
const IMAGE_WIDTH = 40;

function createImage(show) {
  if (!show || show.pending) {
    return <Loader width={8} />;
  }

  let src = show.image && show.image.original;
  if (!src) {
    src = DEFAULT_CHANNEL_IMAGE;
  } else {
    src = getImage(src, { w: IMAGE_WIDTH });
  }
  return (
    <img
      className="overview-shows-list-item-title-image"
      alt={show.name}
      width={IMAGE_WIDTH}
      src={src}
    />
  );
}

const OverviewShowsListItem = props => {
  const { show, onClick } = props;

  const title = limitWithEllipsis(resolve(show || {}, 'name', ''), 40) || <Loader width={8} />;

  return (
    <tr
      className="overview-shows-list-item"
      onClick={e => onClick(e)}
      data-test-id="OverviewShowsListItem"
    >
      <td>{createImage(show)}</td>
      <td>{title}</td>
    </tr>
  );
};

OverviewShowsListItem.propTypes = {
  onClick: T.func,
  show: showPropType.isRequired,
};

OverviewShowsListItem.defaultProps = {
  onClick: () => {},
};

export default OverviewShowsListItem;
